/**
 * The library's "Artistic edit" page (/my-library/artistic/): how it works in four steps, the
 * request form with every video to tick, and the person's own requests with where each one is.
 */
import React, { useEffect, useState } from "react";
import ArtisticRequest from "./ArtisticRequest";
import IridescentCherry from "./IridescentCherry";
import { ART } from "./studioText";
import { getJson, MyStudioRequest, postJson, STUDIO_REQUESTS_URL } from "./studioApi";

/** One of the person's requests: where it is, what they asked, and (while open) "add something". */
const MyRequest: React.FC<{ row: MyStudioRequest; onChange: (r: MyStudioRequest) => void }> = ({ row, onChange }) => {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [note, setNote] = useState("");
  const open = row.status === "new" || row.status === "working";
  const add = async () => {
    if (!text.trim()) return;
    setBusy(true);
    const { ok, data } = await postJson(`${STUDIO_REQUESTS_URL}${row.id}/add/`, { text });
    setBusy(false);
    if (ok) { onChange(data); setText(""); setNote(ART.added); } else setNote(data.message || ART.failed);
  };
  return (
    <div className="art-mine">
      <div className="art-mine-hd">
        <span>{row.created_at ? new Date(row.created_at).toLocaleDateString() : ""}</span>
        <span>{(row.transcript_ids || [row.transcript_id]).length} video(s)</span>
        <b>{ART.statusLabel[row.status] || row.status}</b>
      </div>
      {row.wants && <p className="art-mine-w">“{row.wants}”</p>}
      {(row.additions || []).map((a, i) => <p key={i} className="art-mine-add"><span>{ART.youAdded}:</span> {a.text}</p>)}
      {open && (
        <form className="art-add" onSubmit={(e) => { e.preventDefault(); add(); }}>
          <label>{ART.addTitle}
            <textarea rows={2} value={text} placeholder={ART.addPlaceholder} onChange={(e) => setText(e.target.value)} />
          </label>
          <div><button type="submit" className="pill art-go" disabled={busy || !text.trim()}>{ART.addSend}</button> <span className="meta">{note}</span></div>
        </form>
      )}
    </div>
  );
};

const ArtisticPage: React.FC = () => {
  const [rows, setRows] = useState<MyStudioRequest[]>([]);
  useEffect(() => {
    getJson(STUDIO_REQUESTS_URL).then(({ ok, data }) => { if (ok) setRows(data.requests || []); }).catch(() => {});
  }, []);
  return (
    <div>
      <div className="art-page-hd">
        <IridescentCherry size={48} />
        <div>
          <div className="ttl" style={{ fontSize: 26 }}>{ART.pageTitle} <em className="art-beta">{ART.beta}</em></div>
          <div className="meta">{ART.pitch}</div>
        </div>
      </div>
      <div className="art-steps">
        {ART.pageSteps.map((s, i) => (
          <div key={i} className="art-step"><span className="art-n">{s.icon}</span>{s.text}</div>
        ))}
      </div>
      <ArtisticRequest startOpen />
      {rows.length > 0 && (
        <div className="said-group" style={{ marginTop: 18 }}>
          <div className="ttl" style={{ fontSize: 16, marginBottom: 8 }}>{ART.yourRequests}</div>
          {rows.map((r) => <MyRequest key={r.id} row={r} onChange={(n) => setRows((all) => all.map((x) => (x.id === n.id ? n : x)))} />)}
        </div>
      )}
    </div>
  );
};

export default ArtisticPage;
